/**
 * @generated SignedSource<<97f08bfbf45dc4c040d5e6913252e85a>>
 * @relayHash b1c425aeaf4b2f9118d73159cbe1bf3e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b1c425aeaf4b2f9118d73159cbe1bf3e

import { ConcreteRequest } from 'relay-runtime';
export type IndependentPortfolioPlanSubscriptionStatus = "ACTIVE" | "CANCELED" | "INCOMPLETE" | "INCOMPLETE_EXPIRED" | "PAST_DUE" | "TRIALING" | "UNPAID" | "%future added value";
export type useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation$variables = Record<PropertyKey, never>;
export type useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation$data = {
  readonly refreshIndependentPortfolioPlanSubscription: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly visitor: {
      readonly id: string;
      readonly userAccount: {
        readonly independentPortfolioPlanSubscription: {
          readonly status: IndependentPortfolioPlanSubscriptionStatus;
        } | null;
        readonly profile: {
          readonly hasActivePortfolioSubscription: boolean;
        };
      } | null;
    };
  };
};
export type useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation = {
  response: useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation$data;
  variables: useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasActivePortfolioSubscription",
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefreshIndependentPortfolioPlanSubscriptionPayload",
        "kind": "LinkedField",
        "name": "refreshIndependentPortfolioPlanSubscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Visitor",
            "kind": "LinkedField",
            "name": "visitor",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccount",
                "kind": "LinkedField",
                "name": "userAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndependentPortfolioPlanSubscription",
                    "kind": "LinkedField",
                    "name": "independentPortfolioPlanSubscription",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefreshIndependentPortfolioPlanSubscriptionPayload",
        "kind": "LinkedField",
        "name": "refreshIndependentPortfolioPlanSubscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Visitor",
            "kind": "LinkedField",
            "name": "visitor",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccount",
                "kind": "LinkedField",
                "name": "userAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndependentPortfolioPlanSubscription",
                    "kind": "LinkedField",
                    "name": "independentPortfolioPlanSubscription",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "b1c425aeaf4b2f9118d73159cbe1bf3e",
    "metadata": {},
    "name": "useContraProStripeCheckoutRefreshIndependentPortfolioPlanSubscriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d9d0de422a22b810272f7f7a790e1be3";

export default node;
